import { render, staticRenderFns } from "./BlogSlideCard.vue?vue&type=template&id=1b111982&"
import script from "./BlogSlideCard.vue?vue&type=script&lang=js&"
export * from "./BlogSlideCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports